export const getCarFuelType = (fuelCode?: string): string => {
	switch (fuelCode) {
		case 'H':
			return 'Waterstof';
		case 'B':
			return 'Benzine';
		case 'E85':
			return 'E85';
		case 'BPH':
			return 'Benzine plug-in hybride';
		case 'N':
			return 'Aardgas';
		case 'D':
			return 'Diesel';
		case 'VE':
			return 'Volledig elektrisch';
		case 'BH':
			return 'Benzine hybride';
		case 'G':
			return 'LPG';
		case 'DH':
			return 'Diesel hybride';
		case 'DPH':
			return 'Diesel plug-in hybride';
		default:
			return 'Onbekend';
	}
};
